/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.QuoteAvailableOpgFilter = (function() {

    /**
     * Namespace QuoteAvailableOpgFilter.
     * @exports QuoteAvailableOpgFilter
     * @namespace
     */
    var QuoteAvailableOpgFilter = {};

    QuoteAvailableOpgFilter.QuoteAvailableOpgFilter = (function() {

        /**
         * Properties of a QuoteAvailableOpgFilter.
         * @memberof QuoteAvailableOpgFilter
         * @interface IQuoteAvailableOpgFilter
         * @property {string|null} [countryId] QuoteAvailableOpgFilter countryId
         * @property {string|null} [query] QuoteAvailableOpgFilter query
         * @property {string|null} [sortColumn] QuoteAvailableOpgFilter sortColumn
         * @property {string|null} [sortOrder] QuoteAvailableOpgFilter sortOrder
         * @property {number|null} [pageIndex] QuoteAvailableOpgFilter pageIndex
         * @property {number|null} [pageSize] QuoteAvailableOpgFilter pageSize
         */

        /**
         * Constructs a new QuoteAvailableOpgFilter.
         * @memberof QuoteAvailableOpgFilter
         * @classdesc Represents a QuoteAvailableOpgFilter.
         * @implements IQuoteAvailableOpgFilter
         * @constructor
         * @param {QuoteAvailableOpgFilter.IQuoteAvailableOpgFilter=} [p] Properties to set
         */
        function QuoteAvailableOpgFilter(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * QuoteAvailableOpgFilter countryId.
         * @member {string|null|undefined} countryId
         * @memberof QuoteAvailableOpgFilter.QuoteAvailableOpgFilter
         * @instance
         */
        QuoteAvailableOpgFilter.prototype.countryId = null;

        /**
         * QuoteAvailableOpgFilter query.
         * @member {string|null|undefined} query
         * @memberof QuoteAvailableOpgFilter.QuoteAvailableOpgFilter
         * @instance
         */
        QuoteAvailableOpgFilter.prototype.query = null;

        /**
         * QuoteAvailableOpgFilter sortColumn.
         * @member {string|null|undefined} sortColumn
         * @memberof QuoteAvailableOpgFilter.QuoteAvailableOpgFilter
         * @instance
         */
        QuoteAvailableOpgFilter.prototype.sortColumn = null;

        /**
         * QuoteAvailableOpgFilter sortOrder.
         * @member {string|null|undefined} sortOrder
         * @memberof QuoteAvailableOpgFilter.QuoteAvailableOpgFilter
         * @instance
         */
        QuoteAvailableOpgFilter.prototype.sortOrder = null;

        /**
         * QuoteAvailableOpgFilter pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof QuoteAvailableOpgFilter.QuoteAvailableOpgFilter
         * @instance
         */
        QuoteAvailableOpgFilter.prototype.pageIndex = null;

        /**
         * QuoteAvailableOpgFilter pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof QuoteAvailableOpgFilter.QuoteAvailableOpgFilter
         * @instance
         */
        QuoteAvailableOpgFilter.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * QuoteAvailableOpgFilter _countryId.
         * @member {"countryId"|undefined} _countryId
         * @memberof QuoteAvailableOpgFilter.QuoteAvailableOpgFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailableOpgFilter.prototype, "_countryId", {
            get: $util.oneOfGetter($oneOfFields = ["countryId"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailableOpgFilter _query.
         * @member {"query"|undefined} _query
         * @memberof QuoteAvailableOpgFilter.QuoteAvailableOpgFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailableOpgFilter.prototype, "_query", {
            get: $util.oneOfGetter($oneOfFields = ["query"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailableOpgFilter _sortColumn.
         * @member {"sortColumn"|undefined} _sortColumn
         * @memberof QuoteAvailableOpgFilter.QuoteAvailableOpgFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailableOpgFilter.prototype, "_sortColumn", {
            get: $util.oneOfGetter($oneOfFields = ["sortColumn"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailableOpgFilter _sortOrder.
         * @member {"sortOrder"|undefined} _sortOrder
         * @memberof QuoteAvailableOpgFilter.QuoteAvailableOpgFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailableOpgFilter.prototype, "_sortOrder", {
            get: $util.oneOfGetter($oneOfFields = ["sortOrder"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailableOpgFilter _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof QuoteAvailableOpgFilter.QuoteAvailableOpgFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailableOpgFilter.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailableOpgFilter _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof QuoteAvailableOpgFilter.QuoteAvailableOpgFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailableOpgFilter.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified QuoteAvailableOpgFilter message. Does not implicitly {@link QuoteAvailableOpgFilter.QuoteAvailableOpgFilter.verify|verify} messages.
         * @function encode
         * @memberof QuoteAvailableOpgFilter.QuoteAvailableOpgFilter
         * @static
         * @param {QuoteAvailableOpgFilter.IQuoteAvailableOpgFilter} m QuoteAvailableOpgFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteAvailableOpgFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.countryId != null && Object.hasOwnProperty.call(m, "countryId"))
                w.uint32(10).string(m.countryId);
            if (m.query != null && Object.hasOwnProperty.call(m, "query"))
                w.uint32(18).string(m.query);
            if (m.sortColumn != null && Object.hasOwnProperty.call(m, "sortColumn"))
                w.uint32(26).string(m.sortColumn);
            if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
                w.uint32(34).string(m.sortOrder);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(40).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(48).int32(m.pageSize);
            return w;
        };

        /**
         * Encodes the specified QuoteAvailableOpgFilter message, length delimited. Does not implicitly {@link QuoteAvailableOpgFilter.QuoteAvailableOpgFilter.verify|verify} messages.
         * @function encodeDelimited
         * @memberof QuoteAvailableOpgFilter.QuoteAvailableOpgFilter
         * @static
         * @param {QuoteAvailableOpgFilter.IQuoteAvailableOpgFilter} message QuoteAvailableOpgFilter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteAvailableOpgFilter.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a QuoteAvailableOpgFilter message from the specified reader or buffer.
         * @function decode
         * @memberof QuoteAvailableOpgFilter.QuoteAvailableOpgFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {QuoteAvailableOpgFilter.QuoteAvailableOpgFilter} QuoteAvailableOpgFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteAvailableOpgFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.QuoteAvailableOpgFilter.QuoteAvailableOpgFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.countryId = r.string();
                    break;
                case 2:
                    m.query = r.string();
                    break;
                case 3:
                    m.sortColumn = r.string();
                    break;
                case 4:
                    m.sortOrder = r.string();
                    break;
                case 5:
                    m.pageIndex = r.int32();
                    break;
                case 6:
                    m.pageSize = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a QuoteAvailableOpgFilter message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof QuoteAvailableOpgFilter.QuoteAvailableOpgFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {QuoteAvailableOpgFilter.QuoteAvailableOpgFilter} QuoteAvailableOpgFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteAvailableOpgFilter.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return QuoteAvailableOpgFilter;
    })();

    return QuoteAvailableOpgFilter;
})();

module.exports = $root;
